(function () {
  const FLOAT_ID = 'sacbe-floating-cart';

  function getCartJson() {
    if (!window.routes || !window.routes.cart_url) return Promise.resolve(null);
    return fetch(`${window.routes.cart_url}.js`).then((r) => (r.ok ? r.json() : null));
  }

  function formatCount(n) {
    if (n > 99) return '99+';
    return String(n);
  }

  function setBadgeElements(count) {
    document.querySelectorAll('[data-sacbe-cart-count]').forEach((el) => {
      el.textContent = formatCount(count);
    });

    document.querySelectorAll('[data-sacbe-cart-badge]').forEach((badge) => {
      badge.hidden = count === 0;
    });
  }

  function setFloatingCartVisibility(root, count) {
    if (!root) return;

    const empty = !count;
    root.classList.toggle('sacbe-floating-cart--empty', empty);

    const title =
      (window.sacbeFloatingCart && window.sacbeFloatingCart.cartTitle) || 'Cart';

    if (empty) {
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('tabindex', '-1');
      root.setAttribute('aria-label', title);
    } else {
      root.removeAttribute('aria-hidden');
      root.removeAttribute('tabindex');
      root.setAttribute('aria-label', `${title} (${formatCount(count)})`);
    }
  }

  function syncFromCart(cart) {
    if (!cart) return;
    const count = cart.item_count || 0;

    setBadgeElements(count);

    const float = document.getElementById(FLOAT_ID);
    setFloatingCartVisibility(float, count);
  }

  function sync() {
    return getCartJson().then((cart) => {
      if (cart) syncFromCart(cart);
    });
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => sync());
    }

    document.addEventListener('cart:refresh', () => sync());

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }
  }

  init();
})();
